module.exports = __webpack_public_path__ + "img/icon-time.aad2b192.svg";